import $axios from 'axios'
import { compact, clone } from './utils.js'
import cookies from 'cookies-js'
import get from 'lodash/get'
const apiurl = path => `/referralrest/${path}`
const ts = path => path + '?t=' + new Date().getTime()
const TOKEN_NAME = 'PARTNER_TOKEN'
let DOMAIN = '.vipkid.com.cn'
if (window.location.hostname.indexOf('vipkid-qa.com.cn') > -1) DOMAIN = '.vipkid-qa.com.cn'

const api = {
  /**
   * search partner
   * @param  {Object} params
   * @return {Promise}
   * @see http://code.vipkid.com.cn/teacher-server/partner-referral/wikis/teacher-query#findListByPartner
   */
  search (params) {
    return $axios.post(apiurl('teacher/findListByPartner'), compact(clone(params)))
  },
  /**
   * verifycode
   * @return {Promise}
   */
  verifycode () {
    return $axios.get(ts(apiurl('user/verifycode')))
  },
  /**
   * auth
   * @return {Promise}
   */
  getUserInfo () {
    const promise = $axios.get(ts(apiurl('user/auth')))
    promise.then((e) => {
      if (e.data.data && e.data.data.expires) {
        const day = e.data.data.expires
        e.data.data.expiresDay = `${day} day` + (day > 1 ? 's' : '')
      }
    })
    return promise
  },
  /**
   * login
   * @param  {Object} param  {email,password,key,imageCode}
   * @return {Promise}
   * @see  http://code.vipkid.com.cn/teacher-server/partner-referral/wikis/login#auth
   */
  login (param) {
    return $axios.post(apiurl('user/login'), param).then((e) => {
      const token = get(e, 'data.data.token')
      cookies.set(TOKEN_NAME, token, {
        domain: DOMAIN,
        expires: 12 * 60 * 60
      })
      return e
    })
  },
  /**
   * isLogined
   * @return {Boolean}
   */
  isLogined () {
    return !!cookies.get(TOKEN_NAME)
  },
  /**
   * logout
   * @return {Promise}
   * @see  http://code.vipkid.com.cn/teacher-server/partner-referral/wikis/common#logout
   */
  logout () {
    return $axios.put(apiurl('common/logout')).catch(_ => _)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/referral.api.js